import './button.css';

export default function Button({text, disabled, icon, color, iconColor, onClickHandler}){
    return (
        <button onClick={onClickHandler}  disabled={disabled} className={color ?? 'primary-button'}>
            {text}
            <i className={icon} style={{margin: '3px 4px', alignSelf: 'center', color: iconColor ?? 'black'}}></i>
            {/* <i className="bi bi-arrow-up-right"></i> */}
        </button>
    )
}